import React from "react";
import "./AuthLoader.css";

const AuthLoader = ({ label = "Loading…" }) => {
  return (
    <div
      className="AuthLoader-root"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div className="AuthLoader-stack">
        <div className="AuthLoader-logoWrap">
          <span className="AuthLoader-ring" aria-hidden="true" />
          <img
            className="AuthLoader-logo"
            src={require("../images/iCareVillage_logo.webp")}
            alt="iCareVillage"
          />
        </div>
        <p className="AuthLoader-label">{label}</p>
        <div className="AuthLoader-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default AuthLoader;
